import { FC } from "react";

import ConfirmationPopover from "../../../../components/ConfirmationPopover";
import useOnUpdateRecord from "../../../../hooks/useOnUpdateRecord";
import { AppResource } from "../../../../types/resource.types";
import { productDocRef } from "../../../../utils/referencies";
import { applyUpdateTimestamp } from "../../../../utils/timestamp";

const ProductsDelete: FC<any> = (props) => {
  const onUpdateRecord = useOnUpdateRecord(AppResource.products, "Products have been deleted", "Error on deletion");

  const handleDeleteProduct = async (id: string) => {
    await onUpdateRecord(async () => {
      await productDocRef(id).update(
        applyUpdateTimestamp({
          deleted: true,
        })
      );
    });
  };

  return (
    <ConfirmationPopover
      onConfirm={() => handleDeleteProduct(props.record.id)}
      buttonText="Delete"
      message="Are you sure you want to delete products?"
    />
  );
};

export default ProductsDelete;
